import type { IconName } from '../Icon';
import { Link } from '../Link';
import styles from './Table.module.css';

export interface TableAction {
  disabled?: boolean;
  icon?: IconName;
  label: string;
  onClick: () => void;
}

export interface TableActionsProps {
  actions: readonly TableAction[];
}

/** Figma `Table-Action`：行内文字操作，14px 主题色、间距 12，最多并排 3 个 + 更多。 */
export function TableActions({ actions }: TableActionsProps) {
  return <span className={styles.actions}>{actions.map((action) => <Link disabled={action.disabled} key={action.label} leadingIcon={action.icon} onClick={action.onClick} type="primary">{action.label}</Link>)}</span>;
}
